import View from './ExpensesWorkflowView';

export default View;
